import { ChipProps } from "@mui/material";
import {t} from "@lingui/macro";

export function getChipProps(params: string): ChipProps {
    if (params === 'In contrattazione'){
        return {
            label: params,
            color: 'warning',
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                borderRadius: 1
            }
        }
    }

    if (params === 'Disponibile'){
        return {
            label: params,
            color: 'success',
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                borderRadius: 1
            }
        }
    }

    if (params === 'Non disponibile'){
        return {
            label: params,
            color: 'error',
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                borderRadius: 1
            }
        }
    }

    return {
        label: "Errore",
        color: "error",
        sx: {
            "& .MuiChip-label": {
                color: "background.default"
            },
            borderRadius: 1
        }
    }
}

export function getMatchStatus(params: string): ChipProps {
    switch (params) {
        case "APPROVED":
            return {
                label: t({id: "match-approved", message: "Approvato"}),
                color: 'success',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 1
                }
            }
        case "REJECTED":
            return {
                label: t({id: "match-rejected", message: "Rifiutato"}),
                color: 'error',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 1
                }
            }
        case "CREATED":
            return {
                label: t({id: "match-created", message: "In attesa"}),
                color: 'info',
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 1
                }
            }
        default:
            return {
                label: "Errore",
                color: "error",
                sx: {
                    "& .MuiChip-label": {
                        color: "background.default"
                    },
                    borderRadius: 1
                }
            }
    }
}
